/** @format */

// The `previewMode` AngularJS factory is now registered via PreviewModeService's @DowngradedService
// mapping in app/common/utils/preview-mode.service.ts. This file persists only because PLAN-VIEW
// `app/plan/plan.module.js` side-effect-imports it and `moduleService.js` imports the module-name
// constant below; it folds away with Tier F.
export const previewModeModule = 'student.common.utils.previewMode';